import { combineReducers } from '@reduxjs/toolkit'

import calendarReducer from './calendar'
import academicYearReducer from './academic-year'
import courseReducer from './course.js'

const combinedReducer = combineReducers({
  calendar: calendarReducer,
  academicYear: academicYearReducer,
  course: courseReducer,
})

export default combinedReducer
